<template>
  <layout-report-step
    :isDone="isDone"
    :title="header.title"
    :description="header.description"
    :image="header.image"
    :debug="header.debug"
    :hasInstructions="instruction ? true : false"
    :instructionPictures="instruction.pictures"
    :instructionText="instruction.text"
    :instructionTitle="instruction.title"
  >
    <v-card flat max-width="500" class="pt-4">
      <report-image-upload :example="example" :asset="asset" :instruction="instruction" :type="type" />
    </v-card>
  </layout-report-step>
</template>

<script lang="ts">
import LayoutReportStep from "@/layouts/LayoutReportStep.vue";
import { AssetEnum } from "@/lib/AssetRepository";
import { IReportHeaderData } from "@/lib/interfaces/Report/IReportHeaderData";
import { IReportInstructionData } from "@/lib/interfaces/Report/IReportInstructionData";
import { IReportStep } from "@/lib/interfaces/Report/IViewReportStep";
import ReportImageSubmission from "@/mixins/ReportImageSubmissionMixin.vue";
import { IImageUploaded } from "@/models/Image/IImageUploaded";
import { ReportImageType } from "@/models/Report/ReportImageType";
import { ReportModule } from "@/store/modules/report.store";
import { ReportType } from "@/store/enum/reportType";
import { Component } from "vue-property-decorator";
import { ReportScreenEnum } from "@/store/enum/partner/report-screen.enum";
import ReportImageUpload from "./ReportImageUpload.vue";

@Component({
  components: {
    LayoutReportStep,
    ReportImageUpload
  }
})
export default class ReportGlassDamageImage extends ReportImageSubmission implements IReportStep {
  screen = ReportScreenEnum.glassdamageimage;

  get type() {
    return ReportImageType.glass;
  }

  get isTruck(): boolean {
    return [ReportType.TRUCK, ReportType.TRACTOR_UNIT, ReportType.TRUCK_TRAILER, ReportType.SEMITRAILER].includes(
      ReportModule.reportType
    );
  }

  get asset(): AssetEnum {
    return this.isTruck ? AssetEnum.truckFrontSilhouetteOutline : AssetEnum.glassOutline;
  }

  get example(): AssetEnum {
    return this.isTruck ? AssetEnum.truckFrontSilhouette : AssetEnum.glass;
  }

  get header(): IReportHeaderData {
    return {
      title: "report.imageGlassDamage.title",
      description: "report.imageGlassDamage.description",
      image: this.example,
      debug: this.files
    };
  }

  get instruction(): IReportInstructionData {
    return {
      title: "report.imageGlassDamage.title",
      text: "report.imageGlassDamage.instructionText",
      pictures: [this.example],
      example: this.example,
      display: true
    };
  }

  get isDone(): boolean {
    return this.files.length > 0;
  }

  get files(): IImageUploaded[] {
    return ReportModule.overviews.filter((image) => image.type === ReportImageType.glass);
  }
}
</script>
